import { render, staticRenderFns } from "./HelpContentContainer.vue?vue&type=template&id=72bac443&"
import script from "./HelpContentContainer.vue?vue&type=script&lang=ts&"
export * from "./HelpContentContainer.vue?vue&type=script&lang=ts&"
import style0 from "./HelpContentContainer.vue?vue&type=style&index=0&id=72bac443&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports